import { render, staticRenderFns } from "./PatientAudiogram.vue?vue&type=template&id=741ab28e&scoped=true"
import script from "./PatientAudiogram.vue?vue&type=script&lang=js"
export * from "./PatientAudiogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741ab28e",
  null
  
)

export default component.exports